import { Navigate, Outlet } from "react-router";
import { isAuthenticated } from "../../lib/auth";

const GuestLayout = () => {
  if (isAuthenticated()) {
    return <Navigate to="/dashboard" />;
  }

  return <Outlet />;
};

export default GuestLayout;
